export default {
     create_edit_billing_account_create_title: 'Crear Cuenta de Facturación',
    create_edit_billing_account_edit_title: 'Editar Cuenta de Facturación',
    create_edit_billing_account_successfully_save: 'La cuenta de facturación se guardó correctamente',
    create_edit_billing_account_name: 'Nombre',
    create_edit_billing_account_name_min_error: 'El nombre debe contener un mínimo de caracteres',
    create_edit_billing_account_name_max_error: 'El nombre debe contener un máximo de caracteres',
    create_edit_billing_account_error_save: 'Ocurrió un error al guardar la cuenta de facturación',
    create_edit_billing_account_error_repeated: 'El nombre de la cuenta de facturación ya está registrado',
};